<template>
  <div>
    <div v-if="chapters === null" class="centerPage">
      <loader size="m"/>
    </div>
    <div v-else-if="error !== null">
      Erro ao carregar os capítulos: {{ error }}
    </div>
    <div v-else-if="chapters.length == 0" class="blank-card">
      <md-card>
        <md-card-header>
          Nenhum capítulo encontrado :(
        </md-card-header>
        <md-card-content>
          Comece contando uma história :D
        </md-card-content>
      </md-card>
    </div>
    <div v-else>
      <chapter-medium
        v-for="c in chapters"
        :key="c.id"
        :chapter="c"
        :profile="profile"
        :place="place"
      />
      <load-more
        :show="hasMore"
        :page="options.pagination.page"
        :pageSize="options.pagination.pageSize"
        @loadPage="loadPagination"
      />
    </div>
  </div>
</template>

<script>
import LogRocket from "logrocket";
import chapterMedium from "@/components/shared/chapter/medium";
import loadMore from "@/components/shared/loadMore";
import loader from "@/components/shared/loader";
import call from "@/api/calls";

const log = (error, method, data) => {
  LogRocket.captureException(error, {
    extra: {
      method,
      data
    }
  });
}

export default {
  name: 'chapterList',
  components: {
    chapterMedium,
    loadMore,
    loader
  },
  props: ["pageSize"],
  data() {
    return {
      chapters: null,
      profile: null,
      place: null,
      chapIds: {},
      hasMore: true,
      options: {
        pagination: {
          page: 0,
          pageSize: this.pageSize || 10
        }
      },
      error: null
    }
  },
  watch: {
    '$route.params.id'() {
      this.loadChapters()
    }
  },
  mounted() {
    this.loadChapters(this.options);
  },
  methods: {
    loadChapters(options) {
      return this.sortCall(options)
      .then(chapters => {
        if (chapters.length < this.options.pagination.pageSize)
          this.hasMore = false;
        this.chapters || (this.chapters = []);
        for(let chapter of chapters) {
          if (!this.chapIds[chapter.id]) {
            this.chapters.push(chapter);
            this.chapIds[chapter.id] = true;
          }
        }
      })
      .catch(error => {
        if(!this.$route.params.isProduction)
          return this.staticData();
        this.chapters = error;
        log(error, "loadChapters()", null);
        return this.error = error;
      });
    },
    sortCall(options = {}) {
      if(this.$route.params.user) {
        this.profile = this.$route.params.user;
        return call.chapter.getByAuthor(this.$route.params.id, options);
      }
      else if(this.$route.params.place) {
        this.place = this.$route.params.place;
        return call.chapter.getByGroup(this.$route.params.id, options);
      }
      else return Promise.reject("Invalid params. Expecting user or place.");
    },
    loadPagination(pagination) {
      this.options.pagination = pagination;
      this.loadChapters(this.options);
    },
    staticData() {
      this.chapters = [
        {
          media: {
            image: ["@/assets/coverDefault.png"]
          },
          title: null,
          content: null
        }
      ]
    }
  },
}
</script>

<style scoped>
.blank-card {
  width: 100%;
  padding: 16px;
  margin: 15px auto;
  /* transform: translateX(30px); */
}

.centerPage {
  position: absolute;
  padding: 50px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
